import React from 'react';

import isArray from 'lodash/isArray';

import { DescriptionList, DescriptionItem } from '@gogame/components';

const General = ({ data }) => {
  const normalizedPeriod = isArray(data.period)
    ? data.period
    : [data.period.from, data.period.to];
  return (
    <DescriptionList stripEmpty={true} data={data} disableGutters={true}>
      <DescriptionItem
        label={'Period'}
        value={normalizedPeriod}
        template={'LL'}
        timeZone={'utc'}
        type={'dateRange'}
      />
      <DescriptionItem label={'Affiliate'} field={'affiliate.name'} />
      <DescriptionItem label={'Application'} field={'application.name'} />
      <DescriptionItem label={'Network'} field={'network.name'} />
      <DescriptionItem label={'Cluster'} field={'cluster.name'} />
      <DescriptionItem label={'Platform'} field={'platform.name'} />
      <DescriptionItem
        label={'Campaigns'}
        field={'campaigns'}
        zeroMinWidth={true}
        lineClamp={10}
        tooltipProps={{ placement: 'bottom' }}
        valueParser={'commaList'}
      />
      <DescriptionItem label={'Amount'} field={'amount'} type={'amount'} />
      <DescriptionItem label={'Type'} field={'type.name'} />
      <DescriptionItem label={'Reason'} field={'adjustmentReason.name'} />
    </DescriptionList>
  );
};

export default General;
